import { useMutation, useQuery } from '@tanstack/react-query';

import { getTechnicianList, postPartsOnlyService } from 'queries';
import { parseErrors, Toast } from 'helpers';
import { JsonData, JsonDataItem } from 'types';
import { useState } from 'react';

export const usePartsOnlyJob = (customerId: number) => {
  const [technicianList, setTechnicianList] = useState<JsonData>([]);
  const {
    data: createdJob,
    mutate: createJob,
    isLoading: isJobCreating,
  } = useMutation(postPartsOnlyService, {
    onError: (error: JsonDataItem) => {
      Toast.show({ description: parseErrors(error).join(', '), type: Toast.Type.Error });
    },
  });

  const { isInitialLoading: isTechniciansLoading } = useQuery({
    queryKey: ['technicianList', customerId],
    queryFn: () => getTechnicianList({ serviceType: 1, customerId, getAllTechs: true }),
    enabled: !!customerId,
    onSuccess: (data: JsonData) => {
      setTechnicianList(
        data?.map((group) => ({
          label: group.title,
          options: group.children.map((child: { title: string; value: string }) => ({
            label: child.title,
            value: child.value,
          })),
        })),
      );
    },
    onError: (error: JsonDataItem) => {
      Toast.show({ description: parseErrors(error).join(', '), type: Toast.Type.Error });
    },
  });

  return { createJob, isJobCreating, createdJob, isTechniciansLoading, technicianList };
};
